<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:24:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 14:46:33
--> 
<template>
  <div>
    <!--    :showEdit="hasBtn('edit-staff-version')"
                       :show_del="hasBtn('delete-staff-version')" -->
    <mrc_ess_iconGroup :is_disabled='readonly'
                       :showReturn='false'
                       :showEdit="hasBtn('edit-version-management')"
                       :show_del="hasBtn('delete-version-management')"
                       @handleEdit='handleEdit'
                       @handleDel='handleDel'></mrc_ess_iconGroup>
    <version :disabled='readonly'
             @changeReadonly='handleEdit'></version>
  </div>
</template> 

<script>
import {
  getVersionList
  , addVersion
  , updateVersion
  , deleteVersion
  , detailVersion
} from '@/service/api/version.js'
import version from './version'
export default {
  components: {
    version
  },
  props: {},
  data () {
    return {
      readonly: false,
      list: {}
    };
  },
  computed: {},
  created () { },
  watch: {
    readonly: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_version'
          this.$store.commit('set_page_title', 'label_edit_version')
        }
        else {
          this.$route.meta.title = 'label_view_version'
          this.$store.commit('set_page_title', 'label_view_version')
        }
      }, immediate: true
    }
  },
  mounted () {
    this.readonly = this.$store.state.iconstatus
  },
  beforeDestroy () {

  },
  methods: {
    handleEdit () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', this.readonly)
    },
    handleDel () {
      this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') }).then(res => {
        deleteVersion({ uuid: this.$store.state.uuid }).then(res => {
          if (res.code == 200) {
            this.$Message({ text: this.$t('message_The_deletion_was_successful') })
            this.$router.push({
              name: 'version',
              params: {
                type: 'del'
              }
            })
          }
        })
      })
    },
  },
};
</script>

<style scoped>
</style>
